import { render, staticRenderFns } from "./WelcomeNameCheck.vue?vue&type=template&id=4061fddb&scoped=true&"
import script from "./WelcomeNameCheck.vue?vue&type=script&lang=js&"
export * from "./WelcomeNameCheck.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeNameCheck.vue?vue&type=style&index=0&id=4061fddb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061fddb",
  null
  
)

export default component.exports